var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Cursor extends Component {
    constructor(isDebugEnabled = false) {
        super('Cursor', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (window.matchMedia('(pointer:fine)').matches) {
                Cursor.cursorElement = $.parseHTML('<div class="component-cursor d-none"></div>');
                $('body').append(Cursor.cursorElement);
                $('html').on('mouseleave', () => {
                    Cursor.cursorElement.addClass('d-none');
                });
                $('html').on('mouseenter', () => {
                    Cursor.cursorElement.removeClass('d-none');
                });
                $(window).on('mousemove', Cursor.mouseMoveHandler);
                Cursor.update();
                const lastRawPosition = sessionStorage.getItem('last-cursor-position');
                if (lastRawPosition) {
                    try {
                        Cursor.cursorPosition = Cursor.mousePosition = JSON.parse(lastRawPosition);
                        Cursor.setDotPosition(Cursor.cursorPosition);
                    }
                    catch (_a) { }
                }
            }
            this.success();
        });
    }
    static setDotPosition(position) {
        Cursor.cursorElement.css({
            left: position.x,
            top: position.y,
        });
        Cursor.cursorElement.removeClass('d-none');
    }
    static update() {
        Cursor.cursorPosition = Cursor.inertiaTo();
        Cursor.setDotPosition(Cursor.cursorPosition);
        requestAnimationFrame(Cursor.update);
    }
    static mouseMoveHandler(event) {
        Cursor.mousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (Cursor.isFirstRun) {
            Cursor.cursorPosition = Cursor.mousePosition;
            Cursor.isFirstRun = false;
        }
        sessionStorage.setItem('last-cursor-position', JSON.stringify(Cursor.mousePosition));
        const target = event.target;
        if (target.tagName == 'CANVAS') {
            $('body').addClass('component-cursor-disabled');
        }
        else {
            $('body').removeClass('component-cursor-disabled');
        }
        let isInsideLink = false;
        try {
            isInsideLink = $(target).parents('a').length > 0;
        }
        catch (_a) { }
        if (['A', 'INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].indexOf(target.tagName) != -1 || isInsideLink) {
            if (['text', 'email', 'number', 'password'].indexOf($(target).attr('type')) != -1) {
                Cursor.cursorElement.addClass('component-cursor-text');
            }
            else {
                Cursor.cursorElement.addClass('component-cursor-active');
            }
        }
        else {
            Cursor.cursorElement.removeClass('component-cursor-active component-cursor-text');
        }
        Cursor.cursorElement.removeClass('d-none');
    }
    static inertiaTo() {
        if (Cursor.inertia == 1)
            return Cursor.mousePosition;
        const distanceToGo = {
            x: Cursor.mousePosition.x - Cursor.cursorPosition.x,
            y: Cursor.mousePosition.y - Cursor.cursorPosition.y
        };
        const delta = {
            x: Cursor.cursorPosition.x + distanceToGo.x * Cursor.inertia,
            y: Cursor.cursorPosition.y + distanceToGo.y * Cursor.inertia,
        };
        if (Math.abs(distanceToGo.x) < 0.01)
            delta.x = Cursor.mousePosition.x;
        if (Math.abs(distanceToGo.y) < 0.01)
            delta.y = Cursor.mousePosition.y;
        return delta;
    }
}
Cursor.isFirstRun = true;
Cursor.cursorPosition = { x: 0, y: 0 };
Cursor.mousePosition = { x: 0, y: 0 };
Cursor.inertia = 1;
